import { createSlice } from '@reduxjs/toolkit';

export interface IConditionListProps {
  name: string;
  isVisited: boolean;
}

export interface IConditionItemsProps {
  ItemId: string;
  key: {
    value: string;
  };
}

export interface ISettingDetailsProps {
  path: string;
  parent: {
    parent: {
      name: string;
    };
  };
}

export interface ISitedataForCurrentStudy {
  availableSitesForCurrentStudy: any[];
}

export interface ISiteData {
  availableSites: any[];
  attemptStudies: any[];
  isExist: boolean;
  isDiffRoute: boolean;
  url: string;
  currentRoute: string;
  dynamicJourneyCondition: any;
}

export interface IConditionStudiesList {
  response: any[];
  condition: any;
  uniqueSortedCondition: any[];
}

interface IMultiScreenerSliceProps {
  attemptStudies: string[];
  ConditionItems: IConditionItemsProps[];
  noOfAttempt: number;
  postDataFromScreener: any[];
  conditionListFromSurvey: IConditionListProps[];
  settingDetails: ISettingDetailsProps[];
  isLastQuestionSubmitted: boolean;
  siteData: ISiteData | null;
  ConditionStudiesList: IConditionStudiesList | [];
  sitedataForCurrentStudy: ISitedataForCurrentStudy | [];
}

export const initialState: IMultiScreenerSliceProps = {
  attemptStudies: [],
  ConditionItems: [],
  noOfAttempt: 0,
  postDataFromScreener: [],
  conditionListFromSurvey: [],
  settingDetails: [],
  isLastQuestionSubmitted: false,
  siteData: null,
  ConditionStudiesList: [],
  sitedataForCurrentStudy: {} as ISitedataForCurrentStudy,
};

// type Payload = { [key: string]: string | null };
const multiScreenerSlice = createSlice({
  name: 'multiScreenerSlice',
  initialState,
  reducers: {
    setConditionItems: (state, action) => ({
      ...state,
      ConditionItems: action.payload,
    }),
    setNoOfAttemptToStore: (state, action) => ({
      ...state,
      noOfAttempt: action.payload,
    }),
    setPostDataFromScreener: (state, action) => ({
      ...state,
      postDataFromScreener: [...initialState.postDataFromScreener, ...action.payload],
    }),
    setConditionListFromSurvey: (state, action) => ({
      ...state,
      conditionListFromSurvey: [...initialState.conditionListFromSurvey, ...action.payload],
    }),
    setSettingDetails: (state, action) => ({
      ...state,
      settingDetails: [...initialState.settingDetails, ...action.payload],
    }),
    setAttemptStudies: (state, action) => ({
      ...state,
      attemptStudies: [...initialState.attemptStudies, ...action.payload],
    }),
    setLastQuestionSubmitted: (state, action) => ({
      ...state,
      isLastQuestionSubmitted: action.payload,
    }),
    setSiteData: (state, action) => ({
      ...state,
      siteData: action.payload,
    }),
    setConditionStudiesList: (state, action) => ({
      ...state,
      ConditionStudiesList: action.payload,
    }),
    setSitedataForCurrentStudy: (state, action) => ({
      ...state,
      sitedataForCurrentStudy: action.payload,
    }),
    resetDataForMultiTA: (state) => ({
      ...state,
      sitedataForCurrentStudy: initialState.sitedataForCurrentStudy,
      ConditionStudiesList: initialState.ConditionStudiesList,
      siteData: initialState.siteData,
    }),
  },
});

export const {
  setConditionItems,
  setNoOfAttemptToStore,
  setPostDataFromScreener,
  setConditionListFromSurvey,
  setSettingDetails,
  setAttemptStudies,
  setLastQuestionSubmitted,
  setSiteData,
  setConditionStudiesList,
  setSitedataForCurrentStudy,
  resetDataForMultiTA,
} = multiScreenerSlice.actions;
export default multiScreenerSlice.reducer;
